import React from 'react';
import PropTypes from 'prop-types';
import { STATUS_CODES } from './addProductConstants';

function AddProductError({ buttonState, isButtonClicked }) {
  const { code } = buttonState;

  const isNotification = code === STATUS_CODES.SIZE_OUT_OF_STOCK || code === STATUS_CODES.OUT_OF_STOCK;

  const isError =
    isButtonClicked && (code === STATUS_CODES.ADD_PRODUCT_SELECT_SIZE || code === STATUS_CODES.ADD_PRODUCT_ERROR);

  const outOfStockNonFullPrice =
    code === STATUS_CODES.SIZE_OUT_OF_STOCK_NON_FULL_PRICE || code === STATUS_CODES.OUT_OF_STOCK_NON_FULL_PRICE;

  return (
    (isError || isNotification || outOfStockNonFullPrice) && (
      <p
        role="alert"
        className={`product__error-message  ${isError || outOfStockNonFullPrice ? '_is-active' : ''} ${
          isNotification ? '_is-notification' : ''
        }`}
      >
        {buttonState.errorText}
      </p>
    )
  );
}

AddProductError.propTypes = {
  buttonState: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.bool]))
    .isRequired,
  isButtonClicked: PropTypes.bool.isRequired,
};

export default AddProductError;
